import type { PostBulkSmsEstimate } from "@/server-types";

type BulkSmsPricing = PostBulkSmsEstimate["response"]["pricing"];

export type BulkSmsExtraCost = {
  billedSms: number;
  cents: number;
  currency: string;
};

export function estimateBulkSmsCost({
  totalSms,
  pricing,
}: {
  totalSms: number;
  pricing: BulkSmsPricing;
}): BulkSmsExtraCost | null {
  if (!pricing) return null;

  const billedSms = Math.max(totalSms - pricing.includedRemaining, 0);

  return {
    billedSms,
    cents: Math.round(billedSms * pricing.netPricePerSmsCents),
    currency: pricing.currency,
  };
}
